import { RelatorioInadimplentesPdfResponse } from "core/features/relatorios/typings";
import { PDFLayout } from "ui/components/PDF";
import { formatMoney } from "infra/helpers/number";
import ItemTable from "./components/ItemTable/index";
import { View } from "@react-pdf/renderer";
import colors from "theme/colors";
import TotalRow from "./components/TotalRow/index";
import { RelatorioInadimplentesFields } from "core/features/relatorios/typings";
import ResumoPorCategoria from "components/Relatorio/ResumoPorCategoria";
import { mapItemsTotalWithSelectedFields } from "../util/mapItemsTotalWithSelectedFields";
import moment from "moment";

interface PDFRelatorioInadimplentesProps {
  data?: RelatorioInadimplentesPdfResponse;
  includeDocumentWrapper?: boolean;
  selectedFields?: RelatorioInadimplentesFields[];
}

function PDFRelatorioInadimplentes({
  data,
  includeDocumentWrapper = true,
  selectedFields,
}: PDFRelatorioInadimplentesProps) {
  const apenasCategorias =
    selectedFields?.length === 1 &&
    selectedFields[0] === "resumoContaCategoria";

  const incluirDataPosicao = selectedFields?.includes("dataPosicao");
  const incluirDataEmissao = selectedFields?.includes("dataEmissao");

  const { items: itemsWithMappedTotal, total: mappedTotal } =
    mapItemsTotalWithSelectedFields(data?.items ?? [], selectedFields ?? []);

  return (
    <PDFLayout
      fontSize={7}
      includeDocument={includeDocumentWrapper}
      assinaturas={data?.assinaturas}
      orientation="landscape"
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Relatório de Inadimplentes`,
        fixed: true,
        dataEmissao: incluirDataEmissao
          ? `Data de emissão: ${moment().format("DD/MM/YYYY")}`
          : undefined,
        subTitle:
          incluirDataPosicao && data?.dataPosicao
            ? `Data da posição: ${moment(data?.dataPosicao).format(
                "DD/MM/YYYY"
              )}`
            : undefined,
        cards: selectedFields?.includes("dashboard")
          ? [
              {
                title: "Inadimplentes",
                value: data?.numeroInadimplentes?.toString() || "",
              },
              {
                title: "% inadimplente",
                value: `${(
                  (100 * (data?.numeroInadimplentes || 0)) /
                  (data?.totalUnidades || 1)
                ).toFixed(1)}%`,
              },
              {
                title: "Total principal",
                value: formatMoney(data?.totalPrincipal),
                alignItems: "flex-end",
                shouldHide: !selectedFields?.includes("principal"),
              },
              {
                title: "Total atualizado",
                value: formatMoney(mappedTotal),
                alignItems: "flex-end",
                shouldHide: !selectedFields?.includes("total"),
              },
            ]
          : undefined,
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      {!apenasCategorias &&
        itemsWithMappedTotal?.map((item, index) => (
          <View
            key={item.unidadeId}
            style={{
              marginBottom: index < itemsWithMappedTotal.length - 1 ? 8 : 6,
            }}
          >
            <ItemTable item={item} selectedFields={selectedFields} />
          </View>
        ))}

      {!apenasCategorias && data ? (
        <View
          style={{
            borderTopColor: colors.black,
            borderTopWidth: 2,
            paddingTop: 2,
            fontWeight: "medium",
          }}
        >
          <TotalRow
            title={`${data.numeroInadimplentes || 0} ${
              data.numeroInadimplentes === 1
                ? " inadimplente"
                : " inadimplentes"
            }`}
            total={mappedTotal ?? 0}
            totalCorrecaoMonetaria={data.totalCorrecaoMonetaria}
            totalJuros={data.totalJuros}
            totalMulta={data.totalMulta}
            totalPrincipal={data.totalPrincipal}
            totalTaxaCobranca={data.totalTaxaCobranca}
          />
        </View>
      ) : null}

      {data?.resumoPorCategoria &&
      selectedFields?.includes("resumoContaCategoria") ? (
        <View
          style={{
            marginTop: apenasCategorias ? 0 : 32,
          }}
        >
          <ResumoPorCategoria
            data={{
              resumoPorCategoria: data?.resumoPorCategoria,
            }}
          />
        </View>
      ) : null}
    </PDFLayout>
  );
}

export default PDFRelatorioInadimplentes;
